import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Col, Row, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from 'src/shared/components/form/Select';
import { showNotification } from 'src/shared/components/Notification';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import BusinessIcon from '@mui/icons-material/Business';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DescriptionIcon from '@mui/icons-material/Description';
import SaveIcon from '@mui/icons-material/Save';
import ScheduleIcon from '@mui/icons-material/Schedule';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';

const required = value => value ? undefined : 'Required'

const HubAddOrUpdate = ({ handleSubmit, isShiftName, isShiftId, toggle, dataInfo }) => {
    useEffect(() => {
        GetAllActiveHub();
    }, []);

    const [isActiveHubList, setActiveHubList] = useState(null);
    const [isShiftExist, setShiftExist] = useState(false);

    const GetAllActiveHub = async () => {
        let activeHub = [];
        try {
            const response1 = await PndRestApi.GetAllActiveHub();
            if (response1 && response1.status === 200 && response1.data.status === 200) {
                if (response1.data.data.length > 0) {
                    response1.data.data.forEach(item => {
                        activeHub.push({ "label": item.hubName, "value": item.hubId });
                    });
                    setActiveHubList(activeHub);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response1?.data?.status}`,
                        `Message: Please create a Hub first`,
                    );
                }
            } else if (response1 && response1.status === 200 && response1.data.status === 204) {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1?.data?.status}`,
                    `Message: Please create a Hub first`,
                );
                toggle();
                return;
            }
            else {
                console.error('Unexpected response status:', response1.status);
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1?.data?.status}`,
                    `Message: ${response1?.data?.message}`,
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                "Error",
                "Error fetching data",
            );
        }
    };

    const checShiftAlreadyConfigured = async (selectedHubId) => {
        try {
            const response = await PndRestApi.CheckDutyShiftConfigured(isShiftId, selectedHubId);
            if (response && response.status === 200 && response.data.status === 505) {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message: ${response.data.message}`
                );
                setShiftExist(true);
                return;
            } else {
                setShiftExist(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                "Error",
                "Error fetching data",
            );
        }
    };

    const getDetails = (event) => {
        if (event) {
            checShiftAlreadyConfigured(event?.value);
        }
    };

    const generateShiftTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour <= 11; hour++) {
            const period = hour < 12 ? 'AM' : 'PM';
            const twelveHour = hour % 12 || 12;
            const label = `${twelveHour} ${period}`;
            const value = hour;
            options.push({ value, label });
        }
        options.push({ value: 12, label: '12 PM' });
        for (let hour = 1; hour <= 11; hour++) {
            const period = 'PM';
            const label = `${hour} ${period}`;
            const value = hour + 12;
            options.push({ value, label });
        }
        return options;
    };

    const generateMinutesOptions = () => {
        const options = [];
        options.push({ value: 0, label: "00" });
        for (let minute = 1; minute <= 60; minute++) {
            const minuteLabel = minute.toString().padStart(2, '0');
            options.push({ value: minute, label: minuteLabel });
        }
        return options;
    };

    return (
        <form onSubmit={handleSubmit} className="p-2 bg-light">

            {/* Shift Information Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <ScheduleIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Shift Information</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={12}>
                            <div className="mb-2 p-2 bg-white rounded border">
                                <div className="d-flex align-items-center">
                                    <ScheduleIcon className="me-2 text-primary" style={{ fontSize: '1.5rem' }} />
                                    <div>
                                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.7rem' }}>SHIFT TYPE</label>
                                        <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                            {isShiftName || dataInfo?.shiftTypesInfo?.shiftName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Hub <span className='text-danger'>*</span></label>
                                <Field
                                    validate={[required]}
                                    name="hubInfo"
                                    component={renderSelectField}
                                    type="text"
                                    options={isActiveHubList}
                                    placeholder="Select Hub"
                                    onChange={event => getDetails(event)}
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Shift Description</label>
                                <Field
                                    name="description"
                                    component="textarea"
                                    type="text"
                                    placeholder="Shift Description"
                                    className="form-control form-control-sm"
                                    style={{ fontSize: '0.85rem', minHeight: '38px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Time Configuration Section */}
            <Card className="border-0 shadow-sm mb-2">
                <CardBody className="p-2">
                    <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                        <AccessTimeIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Time Configuration</h6>
                    </div>
                    <Row className="g-2">
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                                    Shift Start Time (HH:MM) <span className='text-danger'>*</span>
                                </label>
                                <div className="d-flex gap-1">
                                    <Field
                                        validate={[required]}
                                        name="shiftStartTimeHH"
                                        component={renderSelectField}
                                        options={generateShiftTimeOptions()}
                                        placeholder="HH"
                                        menuPortalTarget={document.body}
                                    />
                                    <Field
                                        validate={[required]}
                                        name="shiftStartTimeMM"
                                        component={renderSelectField}
                                        options={generateMinutesOptions()}
                                        placeholder="MM"
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                                    Shift End Time (HH:MM) <span className='text-danger'>*</span>
                                </label>
                                <div className="d-flex gap-1">
                                    <Field
                                        validate={[required]}
                                        name="shiftEndTimeHH"
                                        component={renderSelectField}
                                        options={generateShiftTimeOptions()}
                                        placeholder="HH"
                                        menuPortalTarget={document.body}
                                    />
                                    <Field
                                        validate={[required]}
                                        name="shiftEndTimeMM"
                                        component={renderSelectField}
                                        options={generateMinutesOptions()}
                                        placeholder="MM"
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                                    Break Duration (HH:MM) <span className='text-danger'>*</span>
                                </label>
                                <div className="d-flex gap-1">
                                    <Field
                                        validate={[required]}
                                        name="breakDurationHH"
                                        component={renderSelectField}
                                        options={[{ "value": 0, "label": "00" }, { "value": 1, "label": "1" }, { "value": 2, "label": "2" }]}
                                        placeholder="HH"
                                        menuPortalTarget={document.body}
                                    />
                                    <Field
                                        validate={[required]}
                                        name="breakDurationMM"
                                        component={renderSelectField}
                                        options={generateMinutesOptions()}
                                        placeholder="MM"
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Action Bar */}
            {!isShiftExist && (
                <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                    <Button
                        color="primary"
                        type="submit"
                        size="sm"
                        className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
                        style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
                    >
                        <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
                        {dataInfo ? 'Update' : 'Save'}
                    </Button>
                </div>
            )}
        </form>
    );
};

HubAddOrUpdate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
    if (data?.dataInfo) {
        console.log("dataInfo", data?.dataInfo);
    }

    const convertMillisecondsToTime = (milliseconds) => {
        const totalMinutes = Math.floor(milliseconds / 60000);
        const hours24 = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const hours12 = hours24 % 12 || 12;
        const period = hours24 < 12 ? 'AM' : 'PM';
        return { hours: hours12, minutes, period };
    };

    const convertBreakDurationMillisecondsToTime = (milliseconds) => {
        const totalMinutes = Math.floor(milliseconds / 60000);
        const hours24 = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        let hours12 = hours24 % 12 || 12;
        if (hours12 == 12) {
            hours12 = 0;
        }
        return { hours: hours12, minutes };
    };

    const initialValues = {
        breakDurationHH: { value: 0, label: '00' },
        breakDurationMM: { value: 0, label: '00' },
        shiftEndTimeHH: { value: 0, label: '00' },
        shiftEndTimeMM: { value: 0, label: '00' },
        shiftStartTimeHH: { value: 0, label: '00' },
        shiftStartTimeMM: { value: 0, label: '00' },
    };

    if (data && data.dataInfo) {
        const breakDuration = convertBreakDurationMillisecondsToTime(data.dataInfo?.breakDuration);
        const shiftStartTime = convertMillisecondsToTime(data.dataInfo?.shiftStartTime);
        const shiftEndTime = convertMillisecondsToTime(data.dataInfo.shiftEndTime);

        return {
            initialValues: {
                ...initialValues,
                description: data.dataInfo.description,
                shiftId: data.dataInfo?.shiftId,
                breakDurationHH: { value: breakDuration.hours, label: breakDuration.hours.toString() },
                breakDurationMM: { value: breakDuration.minutes, label: breakDuration.minutes.toString().padStart(2, '0') },
                hubInfo: {
                    value: data.dataInfo.hubInfo?.hubId,
                    label: data.dataInfo.hubInfo?.hubName
                },
                shiftStartTimeHH: { value: shiftStartTime.hours, label: `${shiftStartTime.hours} ${shiftStartTime.period}` },
                shiftStartTimeMM: { value: shiftStartTime.minutes, label: shiftStartTime.minutes.toString().padStart(2, '0') },
                shiftEndTimeHH: { value: shiftEndTime.hours, label: `${shiftEndTime.hours} ${shiftEndTime.period}` },
                shiftEndTimeMM: { value: shiftEndTime.minutes, label: shiftEndTime.minutes.toString().padStart(2, '0') },
                shiftTypeId: data.dataInfo?.shiftTypesInfo?.shiftTypeId,
            }
        };
    }

    return { initialValues };
};

export default connect(mapStateToProps)(reduxForm({ form: 'HubAddOrUpdateForm', enableReinitialize: true })(HubAddOrUpdate));